<template>
  <div class="custom-automation-node p-4 border border-gray-300 bg-white shadow-md">
    <Button
      v-if="showMenuIcon"
      icon="pi pi-times"
      class="p-button-text options"
      @click="remove" />
    <div class="top">
      <i :class="['pi', icon]" />
      <div class="flex flex-col">
        <span class="mb-2">{{ header }}...</span>
        <span class="font-normal">{{ title }}</span>
      </div>
    </div>

    <slot style="margin-top: 1rem;" />

  </div>
</template>

<script lang="ts" setup>

import { computed, PropType } from 'vue';
import { simulateOpacity } from '@torim-app/utils';

const props = defineProps({
  data: {
    type: Object,
    required: false
  },
  nodeType: {
    type: String as PropType<'trigger' | 'middle' | 'action'>,
    required: true
  },
  color: {
    type: String,
    default: '#000000'
  },
  icon: {
    type: String,
    required: true
  },
  title: {
    type: String,
    required: true
  },
  showMenuIcon: {
    type: Boolean,
    default: true
  }
});
const emit = defineEmits(['remove']);
const bgColor = simulateOpacity(props.color, 0.1);
const remove = () => {
  emit('remove');
};

const header = computed(() => {
  if (props.nodeType === 'action') return 'בצע';
  if (props.nodeType === 'trigger') return 'כאשר';
  if (props.nodeType === 'middle') return 'ואז';
});
</script>

<style lang="scss" scoped>
.custom-automation-node {
  direction: rtl;
  background-color: white;
  display: flex;
  flex-direction: column;
  width: 100%;
  font-weight: 500;
  font-size: 1.05rem;
  position: relative;
  border-radius: 0.5rem;

  .options {
    position: absolute;
    top: 0;
    left: 0;

    &.p-button {
      color: black;

      background: transparent !important;
    }
  }

  .top {
    display: flex;
    gap: 1rem;
    width: 100%;
    align-items: center;
    justify-content: flex-start;
  }

  .top {
    i {
      display: flex;
      width: 4rem;
      height: 4rem;
      justify-content: center;
      align-items: center;
      background-color: v-bind(bgColor);
      color: v-bind(color);
      font-size: 1.5rem;
      @apply rounded-xl;
    }
  }
}
</style>
